import { getStrapiBaseUrl, getWithLocaleFallback } from "../../services/strapiApi";

// Fonction pour récupérer les données de la page Blog
export const getBlogPageData = async (locale) => {
  return getWithLocaleFallback(
    "/blog-page?populate[heroComponent][populate][0]=image&populate[stats]=*",
    { locale, fallbackLocale: 'fr' }
  );
};

// Fonction pour formater les donnÃ©es de la page Blog
export const formatBlogPageData = (strapiData) => {
  if (!strapiData) {
    return {
      id: null,
      title: "",
      heroComponent: {
        title: "",
        description: "",
        image: "",
      },
      stats: [],
    };
  }

  // Handle both cases: strapiData with attributes or strapiData as attributes directly
  const attributes = strapiData.attributes || strapiData;

  // Extract image URL with multiple fallback strategies
  let heroImageUrl = "";
  if (attributes.heroComponent?.image?.data?.attributes?.url) {
    const imageUrl = attributes.heroComponent.image.data.attributes.url;
    heroImageUrl = imageUrl.startsWith("http")
      ? imageUrl
      : `${getStrapiBaseUrl()}${imageUrl}`;
  } else if (attributes.heroComponent?.image?.data?.url) {
    const imageUrl = attributes.heroComponent.image.data.url;
    heroImageUrl = imageUrl.startsWith("http")
      ? imageUrl
      : `${getStrapiBaseUrl()}${imageUrl}`;
  } else if (attributes.heroComponent?.image?.url) {
    const imageUrl = attributes.heroComponent.image.url;
    heroImageUrl = imageUrl.startsWith("http")
      ? imageUrl
      : `${getStrapiBaseUrl()}${imageUrl}`;
  }

  return {
    id: strapiData.id,
    title: attributes.title || "",
    heroComponent: {
      title: attributes.heroComponent?.title || "",
      description:
        attributes.heroComponent?.description || "",
      image: heroImageUrl,
    },
    stats:
      attributes.stats?.map((stat) => ({
        id: stat?.id,
        value: stat?.value || "",
        label: stat?.title || stat?.label || "", // Changed from 'label' to 'title' based on API response
      })) || [],
  };
};
